"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _InitializingBody = require("./InitializingBody.styled");
var _ = require("../..");
var InitalizingMediaBody = function InitalizingMediaBody(_ref) {
  var type = _ref.type;
  var title = 'SPEAKER';
  var DEFAULT_MESSAGE = "WAITING FOR ".concat(title, " TO JOIN");
  var SCREEN_SHARE_MESSAGE = 'WAITING FOR SCREEN SHARE TO START';
  var initialMessage = type === _.SCREEN_PRESENTER ? SCREEN_SHARE_MESSAGE : DEFAULT_MESSAGE;
  return /*#__PURE__*/_react["default"].createElement(_InitializingBody.InitializedBodyBackground, null, /*#__PURE__*/_react["default"].createElement(_InitializingBody.InitializedBodyText, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faCircleNotch,
    color: "#0095FF",
    spin: true
  }), /*#__PURE__*/_react["default"].createElement(_InitializingBody.InitializedBodyTextContent, null, initialMessage)));
};
InitalizingMediaBody.propTypes = {
  type: _propTypes["default"].string
};
var _default = exports["default"] = InitalizingMediaBody;